import script from "./ProductRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRow.vue?vue&type=script&setup=true&lang=js"

import "./ProductRow.vue?vue&type=style&index=0&id=6b2fa9d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2fa9d2"]])

export default __exports__